export default __webpack_public_path__ + "static/media/12.a7768609.png";